// Stamped by scripts/runCra.js at build time. That script fails rather than emit a
// placeholder, so these are always real values in any bundle that got built.
export const APP_VERSION = process.env.REACT_APP_VERSION;
export const APP_BUILD_ID = process.env.REACT_APP_BUILD_ID;
export const APP_BUILD_TIME = process.env.REACT_APP_BUILD_TIME;
